"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <button
        className="h-9 w-9 border border-zinc-200 hover:border-black transition-colors flex items-center justify-center shrink-0"
        aria-label="Toggle theme"
        data-testid="theme-toggle"
      >
        <div className="h-4 w-4" />
      </button>
    );
  }

  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <button
      onClick={toggle}
      className="h-9 w-9 border border-zinc-200 hover:border-black dark:border-zinc-700 dark:hover:border-white transition-colors flex items-center justify-center shrink-0"
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      data-testid="theme-toggle"
    >
      {theme === "dark" ? (
        <Sun className="h-4 w-4 text-zinc-400 hover:text-white transition-colors" />
      ) : (
        <Moon className="h-4 w-4 text-zinc-600 hover:text-black transition-colors" />
      )}
    </button>
  );
}
